import {BaseChartRequest} from "./BaseChartRequest";

export class RemedialsChartRequest extends BaseChartRequest {

}
